@if (selectEventForm) {
  <div [formGroup]="selectEventForm">
    <ad6-select formControlName="selectedEvent" [label]="'event.list.current' | translate" [options]="eventListOptions">
    </ad6-select>
  </div>
}
